import React from 'react'
import styles from './UnauthorizedPage.module.css'
import { Button } from '@stats/playbook-components'
import { useAuth } from '@/auth/AuthContext';

type UnauthorizedPageProps = {
  message?: string;
};

const UnauthorizedPage: React.FC<UnauthorizedPageProps> = ({ message }) => {
  const { logout } = useAuth();

  return (
    <div className={styles.unauthorizedPageWrapper}>
      <div className={styles.gradientAndLogo}>
        <img
          className={styles.logo}
          src="static/media/Stats_Perform_Logo_white.e4abddf9.svg"
          alt={'Stats Perform logo'}
          height={'58px'}
        />
      </div>
      <span className={styles.mainText}>
        Unauthorized
      </span>
      <span className={styles.secondaryText}>
        {message || 'Not Authorized to Use Application'}
      </span>
      <Button
        className={styles.button}
        variant={'primary'}
        onClick={() => void logout()}
      >
        Logout
      </Button>
    </div>
  )
}

export default UnauthorizedPage